var messageTypes = [
    { "label": "ارسال به همه", value: 0 },
    { "label": "ارسال به همه نمایندگان فروش", value: 1 },
    { "label": "ارسال به همه نصاب ها", value: 2 },
    { "label": "ارسال به یک کاربر", value: 3 },
];

export default messageTypes;
